import { Component, Input, OnInit } from '@angular/core';
import { FormService } from '../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-send-to-client-checkbox',
    templateUrl: './send-to-client-checkbox.component.html',
    styleUrls: ['./send-to-client-checkbox.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FormsModule, FormFieldLabelComponent],
})
export class SendToClientCheckboxComponent implements OnInit {
    @Input() formField: Field | ClientField;

    constructor(public formService: FormService) {}

    ngOnInit(): void {
        if (this.formField.value !== undefined && this.formField.value !== null) {
            this.formField.value = !(this.formField.value === 'false');
        } else if (this.formField.defaultValue) {
            this.formField.value = !(this.formField.defaultValue === 'false');
        }
    }
}
